var map = {
	"./10couch.svg": "ca5a4",
	"./11table.svg": "b3b0",
	"./12cellphone.svg": "ebbb",
	"./13watercraft.svg": "713e",
	"./14mug.svg": "cfc9",
	"./1plane.svg": "b13b",
	"./2bench.svg": "707f",
	"./3cabinet.svg": "0226",
	"./4car.svg": "08de",
	"./5chair.svg": "bb5a",
	"./6monitor.svg": "2643",
	"./7lamp.svg": "4bd9",
	"./8speaker.svg": "ae24",
	"./9firearm.svg": "18ed",
	"./disclamer.svg": "a98c",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";